import React, { useEffect, useState } from "react";
import "./detailsFacture.scss";
import { Box, Button, Chip, Divider, Grid, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { COLORS, dateFormatter, output, priceFormatter } from "../../settings/themeSettings";
import { Print, Refresh, Update } from "@mui/icons-material";
import WestIcon from '@mui/icons-material/West';
import { useNavigate, useParams } from "react-router-dom";
import { fetchFacture } from "../../data/slices/factureSlice";
import useIsAdmin from "../../hooks/useIsAdmin";
import { getClientSageAuxCode } from "../../utils/sageAccountingEngine";

const styles = {
    container: {
        // border: '1px solid blue',
        minHeight: 'calc(100vh - 120px)',
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#ffffff', // Changé de gris à blanc pour meilleure lisibilité
        padding: '16px',
        borderRadius: '12px',
        height: 'fit-content'

    },
    pathtitle: {
        fontSize: '1em',
        fontWeight: 'bold',
        padding: '0 10px',
        width: '100%',
        color: COLORS.tertiary
    },
    path: {
        width: '300px',
        height: '100%',
        //  border: '1px solid red'
    }
}










const DetailsFacture = (props) => {

    const navigateTo = useNavigate();
    const { id, clientId } = useParams();
    const [facture, setFacture] = useState({});
    const [loading, setLoading] = useState(false);
    const isAdmin = useIsAdmin();

    // Fonction retirée : on permet la modification dans tous les cas


    useEffect(() => {


        setLoading(true);

        fetchFacture(id)
            .then((response) => {
                setFacture(response?.data || {});
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                output(err);
            });



    }, [id]);

    const totalBillets = Array.isArray(facture?.billets)
        ? facture.billets.reduce((sum, b) => sum + (Number(b.tarif) || 0), 0)
        : 0;

    const totalFrais = Array.isArray(facture?.frais)
        ? facture.frais.reduce((sum, f) => sum + (Number(f.montant) || 0), 0)
        : 0;

    const totalPaiements = Array.isArray(facture?.paiements)
        ? facture.paiements.reduce((sum, p) => sum + (Number(p.montant) || 0), 0)
        : 0;

    const totalFacture = totalBillets + totalFrais;
    const restant = totalFacture - totalPaiements;

    const statutColor = (value) => {
        if (!value) return 'default';
        if (value === 'PAYEE') return 'success';
        if (value === 'IMPAYEE') return 'error';
        if (value === 'PARTIEL') return 'warning';
        if (value === 'ANNULLEE') return 'default';
        return 'default';
    };










    return (

        loading ?
            <div className="loader-container">
                <span className="loader"></span>
            </div>


            :



            <Box sx={styles.container}>
                <Paper elevation={0} sx={{ p: 2, borderRadius: 3, mb: 2, bgcolor: '#fff' }}>
                    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ xs: 'flex-start', md: 'center' }} justifyContent="space-between">
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Button
                                onClick={() => (clientId && clientId !== 'undefined' && clientId !== 'COMPTANT') ? navigateTo(`/billeterie/factures/${clientId}`) : navigateTo(-1)}
                                variant="contained"
                                color="secondary"
                                startIcon={<WestIcon />}
                                sx={{ borderRadius: 3 }}
                            >
                                Retour
                            </Button>

                            <Stack spacing={0.5}>
                                <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                                    <Typography variant="h5" sx={{ fontWeight: 800, color: COLORS.secondary }}>
                                        Détails facture
                                    </Typography>
                                    <Chip
                                        size="small"
                                        label={facture?.statut || '—'}
                                        color={statutColor(facture?.statut)}
                                        variant="filled"
                                    />
                                </Stack>
                                <Typography variant="body2" color="text.secondary">
                                    {facture?.numeroFacture ? `Facture ${facture.numeroFacture}` : 'Facture'}
                                    {facture?.numeroDossier ? ` · Dossier ${facture.numeroDossier}` : ''}
                                </Typography>
                            </Stack>
                        </Stack>

                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ xs: 'stretch', sm: 'center' }}>
                            <Button 
                                onClick={() => {
                                    const effClient = (clientId && clientId !== 'undefined') ? clientId : (facture?.client?.id || facture?.toClient?.id || 'COMPTANT');
                                    navigateTo(`/billeterie/facture/${effClient}/${id}/pdf`);
                                }} 
                                color="secondary" 
                                variant="outlined" 
                                startIcon={<Print />}
                            >
                                Imprimer facture
                            </Button>
                            <Button
                                disabled={!(facture && facture.paiements && facture.paiements.length >= 1)}
                                onClick={() => {
                                    const effClient = (clientId && clientId !== 'undefined') ? clientId : (facture?.client?.id || facture?.toClient?.id || 'COMPTANT');
                                    navigateTo(`/billeterie/recu/${effClient}/${id}/pdf`);
                                }}
                                color="secondary"
                                variant="outlined"
                                startIcon={<Print />}
                            >
                                Imprimer reçu
                            </Button>
                        </Stack>
                    </Stack>
                </Paper>

                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={7}>
                        <Paper elevation={0} sx={{ p: 2, borderRadius: 3, bgcolor: '#fff', height: '100%' }}>
                            <Typography sx={{ fontWeight: 800, color: COLORS.tertiary, mb: 1 }}>
                                Informations
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            <Stack spacing={1.25}>
                                <Stack direction="row" justifyContent="space-between" spacing={2}>
                                    <Typography variant="body2" color="text.secondary">Client</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 800, color: COLORS.secondary }}>
                                        {facture?.nomClientComptant || (facture?.client ? `${facture.client.nom} ${facture.client.prenom || ''}` : '—')}
                                    </Typography>
                                </Stack>
                                <Stack direction="row" justifyContent="space-between" spacing={2} alignItems="center">
                                    <Typography variant="body2" color="text.secondary">Compte Auxiliaire SAGE</Typography>
                                    <Chip 
                                        size="small" 
                                        label={getClientSageAuxCode(facture?.client, facture?.nomClientComptant)} 
                                        sx={{ fontWeight: 800, bgcolor: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe' }}
                                    />
                                </Stack>
                                <Stack direction="row" justifyContent="space-between" spacing={2}>
                                    <Typography variant="body2" color="text.secondary">N° Facture</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 800, color: COLORS.secondary }}>{facture?.numeroFacture || '—'}</Typography>
                                </Stack>
                                <Stack direction="row" justifyContent="space-between" spacing={2}>
                                    <Typography variant="body2" color="text.secondary">N° Dossier</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 800, color: COLORS.secondary }}>{facture?.numeroDossier || '—'}</Typography>
                                </Stack>
                                <Box>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                                        Commentaire
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 700, color: COLORS.secondary, whiteSpace: 'pre-wrap' }}>
                                        {facture?.commentaire || '—'}
                                    </Typography>
                                </Box>
                            </Stack>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={5}>
                        <Paper elevation={0} sx={{ p: 2, borderRadius: 3, bgcolor: '#fff', height: '100%' }}>
                            <Typography sx={{ fontWeight: 800, color: COLORS.tertiary, mb: 1 }}>
                                Résumé
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            <Stack spacing={1.25}>
                                <Stack direction="row" justifyContent="space-between" spacing={2}>
                                    <Typography variant="body2" color="text.secondary">Billets</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 800, color: COLORS.secondary }}>{priceFormatter(totalBillets)}</Typography>
                                </Stack>
                                <Stack direction="row" justifyContent="space-between" spacing={2}>
                                    <Typography variant="body2" color="text.secondary">Frais</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 800, color: COLORS.secondary }}>{priceFormatter(totalFrais)}</Typography>
                                </Stack>
                                <Divider />
                                <Stack direction="row" justifyContent="space-between" spacing={2}>
                                    <Typography variant="body2" color="text.secondary">Total</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 900, color: COLORS.secondary }}>{priceFormatter(totalFacture)}</Typography>
                                </Stack>
                                <Stack direction="row" justifyContent="space-between" spacing={2}>
                                    <Typography variant="body2" color="text.secondary">Payé</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 800, color: COLORS.secondary }}>{priceFormatter(totalPaiements)}</Typography>
                                </Stack>
                                <Stack direction="row" justifyContent="space-between" spacing={2}>
                                    <Typography variant="body2" color="text.secondary">Restant</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 900, color: restant <= 0 ? '#2e7d32' : '#d32f2f' }}>{priceFormatter(restant)}</Typography>
                                </Stack>
                            </Stack>
                        </Paper>
                    </Grid>
                </Grid>

                <Paper elevation={0} sx={{ p: 2, borderRadius: 3, bgcolor: '#fff', mb: 2 }}>
                    <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} justifyContent="space-between" alignItems={{ xs: 'stretch', md: 'center' }}>
                        <Typography sx={{ fontWeight: 800, color: COLORS.tertiary }}>
                            Actions Billets
                        </Typography>
                        {isAdmin && (
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
                                <Button
                                    onClick={() => navigateTo(`/billeterie/ticket/${clientId}/cancel/${id}`)}
                                    color="secondary"
                                    variant="outlined"
                                    startIcon={<Refresh />}
                                >
                                    Annuler
                                </Button>
                                <Button
                                    onClick={() => navigateTo(`/billeterie/ticket/${clientId}/update/${id}`)}
                                    color="secondary"
                                    variant="outlined"
                                    startIcon={<Update />}
                                >
                                    Update
                                </Button>
                            </Stack>
                        )}
                    </Stack>
                </Paper>

                <Paper elevation={0} sx={{ p: 2, borderRadius: 3, bgcolor: '#fff', mb: 2 }}>
                    <Typography sx={{ fontWeight: 800, color: COLORS.tertiary, mb: 1 }}>
                        Billets
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    <TableContainer component={Paper} elevation={0} sx={{ border: `1px solid ${COLORS.gray[200]}`, borderRadius: 2 }}>
                        <Table size="small" aria-label="billets table">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>N° billet</TableCell>
                                    <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>Nom</TableCell>
                                    <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>Trajet</TableCell>
                                    <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>Vol Aller</TableCell>
                                    <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>Date Aller</TableCell>
                                    <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>Compagnie</TableCell>
                                    <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>Vol Retour</TableCell>
                                    <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>Date Retour</TableCell>
                                    <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>Compagnie</TableCell>
                                    <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>TTC</TableCell>
                                    <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>FA</TableCell>
                                    <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>Etat</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Array.isArray(facture?.billets) && facture.billets.map((billet, idx) => (
                                    <TableRow key={idx} sx={{ 
                                        '& > *': { 
                                            borderBottom: `1px solid #e0e0e0`,
                                            padding: '8px 12px',
                                            color: '#333'
                                        },
                                        '&:hover': {
                                            backgroundColor: '#f9f9f9'
                                        }
                                    }}>
                                        <TableCell sx={{ color: '#333' }}>{billet?.numero}</TableCell>
                                        <TableCell sx={{ color: '#333' }}>{billet?.nom}</TableCell>
                                        <TableCell sx={{ color: '#333' }}>{billet?.trajet}</TableCell>
                                        <TableCell sx={{ color: '#333' }}>{billet?.numeroVol}</TableCell>
                                        <TableCell sx={{ color: '#333' }}>{dateFormatter(billet?.dateVol)}</TableCell>
                                        <TableCell sx={{ color: '#333' }}>{billet?.compagnie}</TableCell>
                                        <TableCell sx={{ color: '#333' }}>{billet?.numeroVolRetour}</TableCell>
                                        <TableCell sx={{ color: '#333' }}>{dateFormatter(billet?.dateVolRetour)}</TableCell>
                                        <TableCell sx={{ color: '#333' }}>{billet?.compagnieRetour}</TableCell>
                                        <TableCell sx={{ color: '#333', fontWeight: 600 }}>{priceFormatter(billet?.tarif)}</TableCell>
                                        <TableCell sx={{ color: '#333', fontWeight: 600 }}>{priceFormatter(billet?.montantAchat)}</TableCell>
                                        <TableCell sx={{ color: '#333' }}>{billet?.etat}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>

                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={0} sx={{ p: 2, borderRadius: 3, bgcolor: '#fff', height: '100%' }}>
                            <Typography sx={{ fontWeight: 800, color: COLORS.tertiary, mb: 1 }}>
                                Frais
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            <TableContainer component={Paper} elevation={0} sx={{ border: `1px solid ${COLORS.gray[200]}`, borderRadius: 2 }}>
                                <Table size="small" aria-label="frais table">
                                    <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>Nature / Motif</TableCell>
                                                <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>CFA</TableCell>
                                            <TableCell sx={{ fontWeight: 800, bgcolor: '#f5f5f5', color: '#333', borderBottom: '2px solid #ddd' }}>EURO</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Array.isArray(facture?.frais) && facture.frais.map((bill, idx) => (
                                            <TableRow key={idx} sx={{ 
                                                '& > *': { 
                                                    borderBottom: `1px solid #e0e0e0`,
                                                    padding: '8px 12px',
                                                    color: '#333'
                                                },
                                                '&:hover': {
                                                    backgroundColor: '#f9f9f9'
                                                }
                                            }}>
                                                <TableCell sx={{ color: '#333' }}>{bill?.nature || bill?.libelle}</TableCell>
                                                <TableCell sx={{ color: '#333', fontWeight: 600 }}>{priceFormatter(bill?.montant)}</TableCell>
                                                <TableCell sx={{ color: '#333', fontWeight: 600 }}>{Math.round((Number(bill?.montant) || 0) / 656)} €</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={0} sx={{ p: 2, borderRadius: 3, bgcolor: '#fff', height: '100%' }}>
                            <Typography sx={{ fontWeight: 800, color: COLORS.tertiary, mb: 1 }}>
                                Paiements
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            <TableContainer component={Paper} elevation={0} sx={{ border: `1px solid ${COLORS.gray[200]}`, borderRadius: 2 }}>
                                <Table size="small" aria-label="paiements table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 800, bgcolor: COLORS.secondary, color: '#FFF' }}>Méthode</TableCell>
                                            <TableCell sx={{ fontWeight: 800, bgcolor: COLORS.secondary, color: '#FFF' }}>Montant</TableCell>
                                            <TableCell sx={{ fontWeight: 800, bgcolor: COLORS.secondary, color: '#FFF' }}>Date</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Array.isArray(facture?.paiements) && facture.paiements.map((payment, idx) => (
                                            <TableRow key={idx}>
                                                <TableCell>{payment?.methode}</TableCell>
                                                <TableCell>{priceFormatter(payment?.montant)}</TableCell>
                                                <TableCell>{dateFormatter(payment?.date)}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
    )

}



export default DetailsFacture;
